import { Form, SubmitButton, HStack, Button } from '@medely/ui-kit';
import React from 'react';
import { WorkHistoryForm } from './components/WorkHistoryForm';
import { WorkHistoryExperienceType, WorkHistoryItemProps, WorkHistoryProps } from './interface';
import { useWorkHistoryActions } from './mutations';
import { NON_CLINICAL_FIELDS } from './constants';
import pick from 'lodash/pick';
import { useAssignmentRequestsForWorkHistoryModal } from './graphql';
import {
  workHistoryClinicalValidationSchema,
  workHistoryNonClinicalValidationSchema,
} from './schema';
import { IResumeItem } from '@medely/types';
import { RenderModalOrPageBottomLayout } from '../RenderModalOrPageBottomLayout';

export const WorkHistoryFormContainer = ({
  workHistory,
  assignmentId,
  goBack,
  isModal = false,
  experienceType,
}: WorkHistoryProps) => {
  const resolvedExperienceType: WorkHistoryExperienceType =
    workHistory?.clinical === false
      ? 'nonClinical'
      : workHistory?.clinical === true
      ? 'clinical'
      : experienceType ?? 'clinical';
  const isClinical = resolvedExperienceType === 'clinical';

  const { addWorkHistory, editWorkHistory, isAddingWorkHistory, isEditingWorkHistory } =
    useWorkHistoryActions(isClinical);

  const { assignmentRequests } = useAssignmentRequestsForWorkHistoryModal(Number(assignmentId));

  const handleSubmit = (values: IResumeItem) => {
    if (workHistory) {
      editWorkHistory(
        {
          values: isClinical ? values : pick(values, NON_CLINICAL_FIELDS),
          assignment_request_id: !!assignmentRequests?.length ? assignmentRequests[0]?.id : null,
        },
        {
          onSuccess: () => {
            goBack?.();
          },
        },
      );
    } else {
      addWorkHistory(
        {
          values: isClinical ? values : pick(values, NON_CLINICAL_FIELDS),
          assignment_request_id: !!assignmentRequests?.length ? assignmentRequests[0]?.id : null,
        },
        {
          onSuccess: () => {
            goBack?.();
          },
        },
      );
    }
  };

  const parseInitialValues = (selectedWorkHistory?: WorkHistoryItemProps) => {
    if (!selectedWorkHistory) {
      return { clinical: isClinical, currently_work_here: false };
    }

    const cityNameOnly = selectedWorkHistory.location?.split(',')[0];

    return {
      ...selectedWorkHistory,
      clinical: selectedWorkHistory.clinical ?? isClinical,
      location: cityNameOnly,
      position_id: selectedWorkHistory.position_id,
    };
  };

  const isMutationLoading = isAddingWorkHistory || isEditingWorkHistory;

  const footerActions = (
    <HStack gap={isModal ? 2 : 0}>
      {isModal && (
        <Button onClick={() => goBack?.()} variant="outlined" fullWidth>
          Back
        </Button>
      )}
      <SubmitButton disabled={isMutationLoading} loading={isMutationLoading} fullWidth>
        Save
      </SubmitButton>
    </HStack>
  );

  return (
    <Form
      handleSubmit={handleSubmit}
      schema={
        isClinical ? workHistoryClinicalValidationSchema : workHistoryNonClinicalValidationSchema
      }
      defaultValues={parseInitialValues(workHistory)}
    >
      <RenderModalOrPageBottomLayout
        isModal={isModal}
        footerActions={footerActions}
        formComponent={<WorkHistoryForm isClinical={isClinical} isEdit={!!workHistory} />}
      />
    </Form>
  );
};
